import script from "./SiconGPT.vue?vue&type=script&setup=true&lang=js"
export * from "./SiconGPT.vue?vue&type=script&setup=true&lang=js"

import "./SiconGPT.vue?vue&type=style&index=0&id=f1ef9950&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1ef9950"]])

export default __exports__